var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"ElButtonMini",style:(_vm.buttonStyle),attrs:{"size":_vm.size,"type":_vm.type,"icon":_vm.iconClass,"title":_vm.title,"disabled":_vm.disabled,"loading":_vm.loading}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }